import { useCallback, useEffect, useState } from 'react';
import moment from 'jalali-moment';
import { startOfWeek } from 'date-fns/startOfWeek';
import { startOfToday } from 'date-fns/startOfToday';
// import { format as jalaliFormat } from 'date-fns-jalali';
import { useSelfContext } from '@/context';

export default function useWeekChangeManagement(
  onSelectDay?: (day: string) => void
) {
  const { changeWeek } = useSelfContext();
  const [currentDot, setCurrentDot] = useState<number>(5);
  const [weekDates, setWeekDates] = useState<string[]>([]);

  const onPressLeft = useCallback(() => {
    setCurrentDot((c) => {
      let newDot = c + 1;
      if (newDot > weekDates.length - 1) newDot = weekDates.length - 1;
      const selectedDate = weekDates[newDot];
      changeWeek(selectedDate);
      if (onSelectDay) {
        const m = moment(selectedDate.split('+')[0]);
        onSelectDay(m.locale('fa').format('YYYY-MM-DD+00:00:00'));
      }
      return newDot;
    });
  }, [changeWeek, weekDates, onSelectDay]);

  const onPressRight = useCallback(() => {
    setCurrentDot((c) => {
      let newDot = c - 1;
      if (newDot < 0) newDot = 0;
      const selectedDate = weekDates[newDot];
      changeWeek(selectedDate);
      if (onSelectDay) {
        const m = moment(selectedDate.split('+')[0]);
        onSelectDay(m.locale('fa').format('YYYY-MM-DD+00:00:00'));
      }
      return newDot;
    });
  }, [changeWeek, weekDates, onSelectDay]);

  const onPressDot = useCallback(
    (index: number) => {
      setCurrentDot(() => {
        const selectedDate = weekDates[index];
        changeWeek(selectedDate);
        if (onSelectDay) {
          const m = moment(selectedDate.split('+')[0]);
          onSelectDay(m.locale('fa').format('YYYY-MM-DD+00:00:00'));
        }
        return index;
      });
    },
    [changeWeek, weekDates, onSelectDay]
  );

  useEffect(() => {
    const day = startOfToday();
    const dates = [];

    const expDate = new Date(day.setDate(day.getDate() - 35));
    const gregorianStartWeek = startOfWeek(expDate);
    let startWeekDay = new Date(
      gregorianStartWeek.setDate(gregorianStartWeek.getDate() - 1)
    );

    for (let i = 0; i < 10; i++) {
      const m = moment(startWeekDay);
      dates.push(m.locale('en').format('YYYY-MM-DD+00:00:00'));
      startWeekDay = new Date(startWeekDay.setDate(startWeekDay.getDate() + 7));
    }

    setWeekDates(dates);
    setCurrentDot(5);
  }, []);

  return { currentDot, onPressLeft, onPressRight, onPressDot, weekDates };
}
